import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Mziki Player - Audio Player',
        projectDesc: 'Mziki Player - Audio Player lets you manage all your music files quickly and easily .This audio player supports almost all types of mp3 , midi ,wav , flac raw aac files and other audio formats . Easily browse and play music songs by genres , albums , artists , songs and folder.        ',
        tags: ['Kotlin', 'CSS', 'Material Ui'],
        code: 'https://play.google.com/store/apps/details?id=com.bkamau.mzikiplayer',
        demo: 'https://play.google.com/store/apps/details?id=com.bkamau.mzikiplayer',
        image: four
    },
    {
        id: 2,
        projectName: 'lipa na mpesa flutter daraja',
        projectDesc: 'Use Mpesa Plugin plugin to implement Lipa Na MPESA Online in your flutter app. This only gives you a payment initialization interface.',
        tags: ['Flutter', 'Android'],
        code: 'https://github.com/BonifaceKamau/lipa_na_mpesa_flutter_daraja',
        demo: 'https://github.com/BonifaceKamau/lipa_na_mpesa_flutter_daraja',
        image: six
    },
    {
        id: 3,
        projectName: 'Hospital App',
        projectDesc: 'An Android hospital-finder-application',
        tags: ['Android', 'Javascript', 'Material Ui'],
        code: 'https://github.com/BonifaceKamau/georeferenced-hospital-finder-application',
        demo: 'https://github.com/BonifaceKamau/georeferenced-hospital-finder-application',
        image: eight
    },
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/